import { Col, Row, Space, Typography, Modal, Dropdown, message } from "antd";
import LanguagesView from "../components/LanguagesView";
import { useState } from "react";
import LanguageFormDialog from "../components/LanguageFormDialog";
import { Language } from "../repository/data.default";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getLanguagesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import { getProblemMessage } from "../utils/http";

function LanguagesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({ conditions: [] });
  const [inputMode, setInputMode] = useState<"add" | "update" | "delete">("add");
  const [inputOpen, setInputOpen] = useState(false);
  const [inputValues, setInputValues] = useState<Language>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(sq: SearchQuery): void {
    setSearchQuery(sq);
  }

  function onInputOpen(mode: "add" | "update" | "delete", values?: Language): void {
    setInputMode(mode);
    setInputOpen(true);
    setInputValues(values || ({} as any));
  }

  function onInputFinish(): void {
    setInputOpen(false);
    setInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading languages export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getLanguagesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => loading.destroy())
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Languages
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("Languages", "create")}
            className={`${!permissions.can("Languages", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("Languages", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onInputOpen("add")}
          >
            Add Language
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <LanguagesView
          trigger={triggerView}
          onAction={(key: string, record: any) => onInputOpen(key as any, record)}
          onSearch={onSearch}
        />
      </Col>
      <LanguageFormDialog
        key={inputMode}
        mode={inputMode}
        open={inputOpen}
        initialValues={inputValues}
        onFinish={onInputFinish}
        onCancel={() => setInputOpen(false)}
      />
      {contextHolder}
    </Col>
  );
}

export default LanguagesPage;
